"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultSetFavouriteAssessmentsCommandHandler = void 0;
const domain_1 = require("../../domain");
const base_wishlist_command_handler_1 = require("../base-wishlist-command-handler");
class DefaultSetFavouriteAssessmentsCommandHandler extends base_wishlist_command_handler_1.BaseWishlistCommandHandler {
    constructor(wishlistRepository, eventEmitter) {
        super(wishlistRepository);
        this.wishlistRepository = wishlistRepository;
        this.eventEmitter = eventEmitter;
    }
    validate(command) {
        if (typeof command.studyId !== 'number') {
            throw new domain_1.FavouriteInvalidStudyId(command.studyId);
        }
    }
    handle({ studyId, userId, assessments, expectedState, isLocal }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.validate({ studyId, userId, assessments, expectedState, isLocal });
                const wishlist = yield this.getWishlist(userId, expectedState);
                const favourite = wishlist.findFavourite(studyId);
                if (!favourite) {
                    throw new domain_1.FavouriteNotFound(wishlist.userId, studyId);
                }
                const timestamp = this.getCurrentDate();
                favourite.setAssessments(assessments);
                yield this.wishlistRepository.setFavouriteAssessments(wishlist, studyId, assessments);
                yield this.emitFavouriteAssessmentsChanged(userId, studyId, assessments, wishlist.stateHash, timestamp, isLocal);
                return {
                    resultingState: wishlist.stateHash,
                };
            }
            catch (error) {
                throw error;
            }
        });
    }
    emitFavouriteAssessmentsChanged(userId, studyId, assessments, stateHash, timestamp, isLocal) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.eventEmitter.emit(domain_1.FavouriteAssessmentsChanged.EventType, domain_1.FavouriteAssessmentsChanged.create(userId, studyId, assessments, stateHash, timestamp, isLocal));
        });
    }
}
exports.DefaultSetFavouriteAssessmentsCommandHandler = DefaultSetFavouriteAssessmentsCommandHandler;
